import { fetchEndpoint } from '../network'

/**
 * 内容管理 - 合集管理
 */

export default {

    // 视频列表
    videos(params) {
      return fetchEndpoint(
        '/create-platform/content/video',
        'GET',
        params
      )
    },

    // 创建视频
    create(params) {
      return fetchEndpoint(
        '/create-platform/content/video',
        'POST',
        params
      )
    },

    // 视频详情
    detail(params) {
      return fetchEndpoint(
        '/create-platform/content/video/detail',
        'GET',
        params
      )
    },

    // 修改视频
    modify(params) {
      return fetchEndpoint(
        '/create-platform/content/video/modify',
        'POST',
        params
      )
    },

    // 删除视频
    remove(params) {
      return fetchEndpoint(
        '/create-platform/content/video/delete',
        'POST',
        params
      )
    },

    // 提交审核
    examine(params) {
      return fetchEndpoint(
        '/create-platform/content/video/examine',
        'POST',
        params
      )
    },

    // // 发布
    // publish(params) {
    //   return fetchEndpoint(
    //     '/content/video-collection/publish',
    //     'POST',
    //     params
    //   )
    // },

    // 显示
    show(params){
      return fetchEndpoint(
        '/create-platform/content/video/show',
        'POST',
        params
      )
    },

    // 隐藏
    hide(params){
      return fetchEndpoint(
        '/create-platform/content/video/hidden',
        'POST',
        params
      )
    },

    // 撤稿
    revert(params){
      return fetchEndpoint(
        '/create-platform/content/video/revert',
        'POST',
        params
      )
    },

    // 弹窗中搜索视频列表
    searchVideos(params) {
      return fetchEndpoint(
        '/content/config',
        'GET',
        params
      )
    },

    baseConf(params) {
      return fetchEndpoint(
        '/create-platform/longyuan/baseConf',
        'GET',
        params
      )
    },

    longyuanExamine(params){
      return fetchEndpoint(
        '/create-platform/longyuan/publish',
        'POST',
        params
      )
    },

    // 发布
    publish(params) {
      return fetchEndpoint(
        '/create-platform/content/video/publish',
        'POST',
        params
      )
    },


    // 获取红包情况
    redPacketInfo(params) {
      return fetchEndpoint(
        '/create-platform/redPacket/info',
        'GET',
        params
      )
    },

    // 获取红包记录
    redPacketHistory(params) {
      return fetchEndpoint(
        '/create-platform/redPacket/history',
        'GET',
        params
      )
    },


}









